"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _palette = require("../../../styles/palette");

var _style = require("./style");

var Title = function Title(_ref) {
  var claim = _ref.claim,
      claimColor = _ref.claimColor,
      description = _ref.description,
      title = _ref.title,
      titleColor = _ref.titleColor;
  return _react["default"].createElement(_style.Container, null, title && _react["default"].createElement(_style.TitleStyled, {
    titleColor: titleColor
  }, title), claim && _react["default"].createElement(_style.Claim, {
    claimColor: claimColor
  }, claim), description && _react["default"].createElement(_style.Description, null, description));
};

Title.propTypes = {
  claim: _propTypes["default"].string,
  claimColor: _propTypes["default"].string,
  description: _propTypes["default"].string,
  title: _propTypes["default"].string,
  titleColor: _propTypes["default"].string
};
Title.defaultProps = {
  claim: '',
  claimColor: _palette.palette.bobBlack,
  description: '',
  title: '',
  titleColor: _palette.palette.grey
};
var _default = Title;
exports["default"] = _default;